module.exports = __webpack_public_path__ + "static/media/cog.1944e15a.svg";